interface Props {
   color?: string;
}

const SearchIcon: React.FC<Props> = ({ color = "#0D0C21" }) => {
   return <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.4 2.3999C5.99122 2.3999 2.40002 5.9911 2.40002 10.3999C2.40002 14.8087 5.99122 18.3999 10.4 18.3999C12.3172 18.3999 14.0779 17.7191 15.4578 16.589L20.2344 21.3655C20.435 21.5745 20.733 21.6587 21.0134 21.5856C21.2937 21.5125 21.5126 21.2936 21.5857 21.0132C21.6588 20.7329 21.5746 20.4349 21.3656 20.2343L16.5891 15.4577C17.7192 14.0778 18.4 12.3171 18.4 10.3999C18.4 5.9911 14.8088 2.3999 10.4 2.3999ZM10.4 3.9999C13.9441 3.9999 16.8 6.8558 16.8 10.3999C16.8 13.944 13.9441 16.7999 10.4 16.7999C6.85593 16.7999 4.00002 13.944 4.00002 10.3999C4.00002 6.8558 6.85593 3.9999 10.4 3.9999Z" fill={color} />
   </svg>;
}

export default SearchIcon;